const solutionsModule = document.querySelectorAll('.solutions-simulator');
const solutionsLinks = document.querySelectorAll('.solutions-simulator__link');
const solutionsImages = document.querySelectorAll('.solutions-simulator__image');

if (solutionsModule.length > 0) {
  const solutionsController = new ScrollMagic.Controller();

  const solutionsSliderOptions = {
    slidesPerView: 1,
    speed: 800,
    spaceBetween: 0,
    allowTouchMove: false,
    simulateTouch: false,
    effect: 'creative',
    direction: 'vertical', // vertical sliding
    creativeEffect: {
      prev: {
        shadow: false,
        translate: [0, '20%', -1], // Y-axis translation
      },
      next: {
        translate: [0, '-100%', 0], // Y-axis translation
      },
    },
  };

  solutionsModule.forEach((el) => {
    const sliderElem = el.querySelector('[data-slider="solutions-simulator"]');
    const links = el.querySelectorAll('.solutions-simulator__link');
    const slider = new Swiper(sliderElem, solutionsSliderOptions);

    links.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        const index = link.getAttribute('data-item');
        const image = el.querySelector(`[data-image="${index}"]`);

        removeActiveClass([...solutionsLinks, ...solutionsImages]);

        link.classList.add('is-active');
        image.classList.add('is-active');

        slider.slideTo(index, 800);
      });
    });

    new ScrollMagic.Scene({
      triggerElement: sliderElem,
      triggerHook: 0,
      duration: '200%',
    })
      .setClassToggle(el, 'is-active') // add/remove class
      .addTo(solutionsController);

    // if (isLocal()) {
    //   solutionsScene.addIndicators({ name: 'Enlarge solutions slider' });
    // }
  });
}
